export const GETCARTREQUEST = 'GETCARTREQUEST'
export const GETCARTSUCCESS = 'GETCARTSUCCESS'
export const GETCARTFAILURE = 'GETCARTFAILURE'  


export const POSTCARTREQUEST = 'POSTCARTREQUEST'
export const POSTCARTSUCCESS = 'POSTCARTSUCCESS'
export const POSTCARTFAILURE = 'POSTCARTFAILURE'  

export const EMPTY_CART="EMPTY_CART"